var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal-header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"modal-content scroll"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }